/* Noa: in-cart size switcher.
   Swaps a line item's variant by removing the old line and adding the new one
   through Shopify's public /cart/change + /cart/add endpoints, then asks the
   theme to re-render the drawer. */
(function () {
  if (customElements.get('noa-size-switch')) return;

  class NoaSizeSwitch extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      if (!this.select) return;
      this.select.addEventListener('change', this.onChange.bind(this));
    }

    async onChange() {
      var newId = this.select.value;
      var lineItem = this.closest('line-item');
      var key = lineItem && lineItem.querySelector('[data-line-key]');
      var oldKey = key ? key.getAttribute('data-line-key') : null;
      if (!oldKey) return;

      var qtyInput = lineItem.querySelector('input[name="quantity"], .quantity-selector input');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      this.classList.add('is-busy');
      try {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: oldKey, quantity: 0 })
        });
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(newId), quantity: qty }] })
        });
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      } catch (e) {
        this.classList.remove('is-busy');
      }
    }
  }

  customElements.define('noa-size-switch', NoaSizeSwitch);
})();
